<template>
    <div class="providerSection">
        <h1>
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiInformationVariant }}
            </v-icon>
            <span>Provider Information</span>
        </h1>
        <v-card
            v-if="docInfoData"
            class="docInfoBody"
            elevation="10"
        >
            <v-icon
                icon
                x-large
                color="#00E676"
                class="white--text"
                style="height: 40px; width: 40px; font-size: 30px; background-color: #00E676; border-radius: 25px;"
            >
                {{ mdiHospital }}
            </v-icon>
            <table class="providerData">
                <tr>
                    <td class="rowLabel">
                        Provider Name
                    </td>
                    <td class="docData">
                        {{ docInfoData.NAME }}
                    </td>
                </tr>
                <tr>
                    <td class="rowLabel">
                        Address
                    </td>
                    <td class="docData">
                        {{ docInfoData.ADDRESS }}
                    </td>
                </tr>
                <tr>
                    <td class="rowLabel">
                        Accreditation Status
                    </td>
                    <td class="docData">
                        {{ docInfoData.STATUS }}
                    </td>
                </tr>
                <tr>
                    <td class="rowLabel">
                        Accreditation Date
                    </td>
                    <td class="docData">
                        {{ getAccreditationDate }}
                    </td>
                </tr>
            </table>
            <v-simple-table
                v-if="getLinkedProvidersData && getLinkedProvidersData.data.length > 0"
                style="padding: 0 4%;"
            >
                <template #default>
                    <thead>
                        <tr>
                            <th colspan="2" class="text-left black--text">
                                Affiliated Hospitals or Clinics
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(provider, index) in getLinkedProvidersData.data" :key="index">
                            <td style="width: 50px; text-align: center;">
                                {{ index + 1 }}.
                            </td>
                            <td>{{ provider.hosp_name }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </div>
</template>

<script>
import { mdiHospital, mdiInformationVariant } from '@mdi/js'
import { moment } from '../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: ()=>({
        mdiHospital, mdiInformationVariant,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['docInfoData', 'getLinkedProvidersData']),
        getAccreditationDate() {
            return this.docInfoData.ACCREDITATION_DATE !== '-'
                ? moment(this.docInfoData.ACCREDITATION_DATE).format('MMMM DD, YYYY')
                : '-'
        }
    },
    async created() {
        await this.getData()
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'getProviderInfo', 'getLinkedProviders']),
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        },
        async getData() {
            const PROVIDER_ID = this.$cookies.get('provider_id')
            await this.getProviderInfo({ PROVIDER_ID })
            this.getLinkedProviders({ MSU_C: PROVIDER_ID })
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
    padding: 3%;
}
    .providerData {
        width: 90%;
        margin: 5% 5%;
    }
        .rowLabel {
            font-size: 14px;
            font-weight: 700;
        }
        .providerData tr td {
            padding: 1% 1%;
        }
.providerSection {
    padding: 10px 7.5% 0 7.5%;
    margin-bottom: 5%;
}
@media (max-width: 380px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
    margin-bottom: 5%;
  }
}
@media (max-width: 599px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
    margin-bottom: 5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
    margin-bottom: 5%;
  }
}
@media (min-width: 1264px) {
  .providerSection {
    padding: 10px 7.5% 0 7.5%;
    margin-bottom: 5%;
  }
}
</style>
